// extracted by mini-css-extract-plugin
module.exports = {"form-input":"LoginForm_form-input__2d-Xf","input":"LoginForm_input__PaKkK","form":"LoginForm_form__1sNDe","icon":"LoginForm_icon__utpJs"};